import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { envChangeType } from "../../../../../../plugins/utils";
import styles from "./styleModule";

const BrandItem = ({ brand, active = false, onClick = () => {} }) => {
  const { t } = useTranslation();
  const renderContent = () => {
    return (
      <div
        className={`${styles.brandContainer} ${active ? styles.active : ""}`}
        onClick={() => {
          onClick(brand?.game_3th_code);
        }}
      >
        <img
          className={`${styles.image}`}
          src={
            brand?.game_3th_code.includes("all")
              ? `/images/platform/brand/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/all.png`
              : `/images/platform/brand/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${brand?.game_3th_code}.png`
          }
          alt={brand?.game_3th_code}
        />
        <div className={`${styles.title} ${active ? styles.active : ""}`}>
          {t([
            `home.games.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${brand?.game_3th_code}`,
            `home.games.${brand?.game_3th_code}`,
          ])}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!brand) return;
    // console.debug("brand", brand);
  }, [brand]);

  return renderContent();
};
export default BrandItem;
